import React from "react";
import { Table, Card } from "react-bootstrap";
import SimActionsDropdown from "./SimActionsDropdown";
import SimPagination from "./SimPagination";
import ScrollSyncWrapper from "../../../utils/ScrollSyncWrapper";

const DataCard = ({
  getTableProps,
  getTableBodyProps,
  headerGroups,
  page,
  prepareRow,
  pageNumber,
  pageRecords,
  numberOfRecords,
  setShownSim,
  getSimCellInfo,
  setCellInfo,
  setOpen,
  setSingleIsShown,
  t,
  pageIndex,
  setPageRecords,
  setPageNumber,
  gotoPage,
  nextPage,
  previousPage,
  setPageSize,
  selectedRows,
  setSelectedRows,
  clearSelectedRows,
  filters,
  setIsLoading,
  demoMode,
}) => {
  return (
    <Card>
      <Card.Body>
        <SimActionsDropdown
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          clearSelectedRows={clearSelectedRows}
          pageIndex={pageIndex}
          pageRecords={pageRecords}
          filters={filters}
          setIsLoading={setIsLoading}
          sims={page}
          demoMode={demoMode}
        />
        <hr />
        <ScrollSyncWrapper>
          <Table id="simsTable" hover {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      <span {...column.getSortByToggleProps()}>
                        {column.render("Header")}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    onClick={() => {
                      setShownSim(row.original);
                      setOpen(true);
                      setTimeout(function () {
                        setSingleIsShown(true);
                      }, 500);
                    }}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </ScrollSyncWrapper>

        <SimPagination
          pageNumber={pageNumber}
          numberOfRecords={numberOfRecords}
          pageRecords={pageRecords}
          setPageSize={setPageSize}
          setPageRecords={setPageRecords}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          setPageNumber={setPageNumber}
          previousPage={previousPage}
          nextPage={nextPage}
          t={t}
        />
      </Card.Body>
    </Card>
  );
};

export default DataCard;
